module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/seaside-summer-cbe0fd8d1ae2f2b03d7f9983c7d1afd2.jpg";